import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "@/views/home/Index.vue";
import Login from "@/views/login/Index.vue";
import NewsSection from "@/views/news/Section.vue";
import NewsList from "@/views/news/List.vue";
import NewsDetail from "@/views/news/Detail.vue";
import NewsSearchResult from "@/views/news/SearchResult.vue";
import VideoSection from "@/views/video/Section.vue";
import VideoList from "@/views/video/List.vue";
import VideoDetail from "@/views/video/Detail.vue";
import ImageTextSection from "@/views/imageText/Section.vue";
import ImageTextList from "@/views/imageText/List.vue";
import BbsList from "@/views/bbs/List.vue";
import BbsDetail from "@/views/bbs/Detail.vue";
import Dictionary from "@/views/dictionary/List.vue";
import BookList from "@/views/book/List.vue";
import BookDetail from "@/views/book/Detail.vue";
import UserInfo from "@/views/user/UserInfo.vue";
import UserFavorite from "@/views/user/UserFavorite.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/newsSection",
    name: "NewsSection",
    component: NewsSection,
  },
  {
    path: "/newsList",
    name: "NewsList",
    component: NewsList,
  },
  {
    path: "/newsDetail",
    name: "NewsDetail",
    component: NewsDetail,
  },
  {
    path: "/newsSearchResult",
    name: "NewsSearchResult",
    component: NewsSearchResult,
  },
  {
    path: "/videoSection",
    name: "VideoSection",
    component: VideoSection,
  },
  {
    path: "/videoList",
    name: "VideoList",
    component: VideoList,
  },
  {
    path: "/videoDetail",
    name: "VideoDetail",
    component: VideoDetail,
  },
  {
    path: "/imageTextSection",
    name: "ImageTextSection",
    component: ImageTextSection,
  },
  {
    path: "/imageTextList",
    name: "ImageTextList",
    component: ImageTextList,
  },
  {
    path: "/bbsList",
    name: "BbsList",
    component: BbsList,
  },
  {
    path: "/bbsDetail",
    name: "BbsDetail",
    component: BbsDetail,
  },
  {
    path: "/dictionaryList",
    name: "Dictionary",
    component: Dictionary,
  },
  {
    path: "/bookList",
    name: "BookList",
    component: BookList,
  },
  {
    path: "/bookDetail",
    name: "BookDetail",
    component: BookDetail,
  },
  {
    path: "/userInfo",
    name: "UserInfo",
    component: UserInfo,
  },
  {
    path: "/userFavorite",
    name: "UserFavorite",
    component: UserFavorite,
  },
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior(to, from, savePosition) {
    if (savePosition) {
      return savePosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  base: process.env.BASE_URL,
  routes,
});

export default router;
